import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

export class RadioboxCell extends Component {
    static propTypes = {
        setSelected: PropTypes.func.isRequired,
        checkDisabled: PropTypes.func,
        selected: PropTypes.oneOfType([
            PropTypes.number.isRequired,
            PropTypes.string.isRequired
        ]),
        rowIndex: PropTypes.oneOfType([
            PropTypes.number.isRequired,
            PropTypes.string.isRequired
        ])
    };

    handleClick = () => {
        const index = this.props.selected !== this.props.rowIndex ? this.props.rowIndex : null;

        this.props.setSelected(index);
    }

    render() {
        const { rowIndex, selected, checkDisabled } = this.props;

        const disabled = checkDisabled && checkDisabled(this.props);

        return (
            <div className="table-cell-center">
                <Checkbox
                    onChange={this.handleClick}
                    disabled={disabled}
                    checked={selected === rowIndex}
                />
            </div>
        );
    }
}
